import React, { useRef, useEffect } from 'react';

const options = {
    root: null,
    rootMargin: '0px',
    threshold: 1,
};

type LoadMoreProps = {
    onloadMore: () => void;
} & React.HTMLAttributes<HTMLDivElement>;

/**
 * This component is used to trigger the infinite scroll for pipeline steps
 */
export const LoadMore = ({ onloadMore, ...props }: LoadMoreProps) => {
    const ref = useRef(null);

    const callback: IntersectionObserverCallback = (entries) => {
        if (entries[0].isIntersecting) {
            onloadMore();
        }
    };
    useEffect(() => {
        const observer = new IntersectionObserver(callback, options);
        if (ref.current) {
            observer.observe(ref.current);
        }
        return () => {
            observer.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- ref is intentionally stable, no need to include in deps
    }, [ref]);
    return <div ref={ref} {...props} />;
};
